import { PaymentIcon, PaymentIconName } from "src/components/unstyled/PaymentIcon"

const paymentMethods: { icon: PaymentIconName; name: string }[] = [
  { icon: "paypal", name: "PayPal" },
  { icon: "klarna", name: "Klarna" },
  { icon: "mastercard", name: "Mastercard" },
  { icon: "visa", name: "Visa" },
  { icon: "sepa", name: "SEPA" },
]

export type PaymentMethodData = {
  name: string
  icon: string
  background?: string
}

export const PaymentMethods = () => {
  return (
    <ul className="flex w-full max-w-sm items-center justify-between gap-2 px-2">
      {paymentMethods.map((method, index) => (
        <li key={index} title={method.name}>
          <PaymentIcon name={method.icon} className="aspect-[64/48] size-full object-contain" />
        </li>
      ))}
    </ul>
  )
}
